import { render } from "./LastUpdate.vue?vue&type=template&id=d0d4a526&scoped=true"
import script from "./LastUpdate.vue?vue&type=script&lang=js"
export * from "./LastUpdate.vue?vue&type=script&lang=js"

import "./LastUpdate.vue?vue&type=style&index=0&id=d0d4a526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d4a526"]])

export default __exports__